// checkLivestreamChatPreflightAndOpenPanel.js
'use strict';
import { MERGE_OPERATION_DATA } from '../ActionTypes.js';
import getOperationData from '../selector/getOperationData.js';
import setLiveStreamPanel from '../action/setLiveStreamPanel.js';
import checkLivestreamChatPreflight from '../action/checkLivestreamChatPreflight.js';
import getTimestampOffset, {
  Accuracy,
} from '../selector/getTimestampOffset.js';
import getCurrentUnixTimestamp from '../resource/getCurrentUnixTimestamp.js';

/**
 * Check livestream chat preflight and set panel
 * @kind action
 * @param {string} {streamId} - action param.
 * @param {bool} {isSuperChatOpen} - open the panel in super chat mode or not.
 * @return {Promise} Action promise.
 */
const checkLivestreamChatPreflightAndOpenPanel =
  ({ streamId, isSuperChatOpen = false }) =>
  async (dispatch, getState) => {
    const selectPath = ['liveStream', streamId, 'chat', 'preflight'];
    // Super chat can't be combined with pin or livestream alert, so turn both
    // off when the panel opens. Doing it any earlier would also clear them
    // when the preflight fails.
    const openPanel = () => {
      if (isSuperChatOpen) {
        dispatch({
          type: MERGE_OPERATION_DATA,
          payload: {
            selectPath: ['liveStream', 'chat', streamId],
            data: {
              shouldPinMessage: false,
              shouldUseLivestreamAlert: false,
            },
          },
        });
      }
      return dispatch(
        setLiveStreamPanel({ isChatPanelOpen: true, isSuperChatOpen })
      );
    };
    const timestampOffsetSeconds = getTimestampOffset(
      getState(),
      Accuracy.SECOND
    );
    const now = getCurrentUnixTimestamp({
      offsetSeconds: timestampOffsetSeconds,
    });
    const exp = getOperationData(getState(), selectPath, 'exp');
    if (exp && exp > now) return openPanel();

    await dispatch(checkLivestreamChatPreflight({ streamId }));

    const newExp = getOperationData(getState(), selectPath, 'exp') || 0;
    if (newExp > now) return openPanel();
  };

export default checkLivestreamChatPreflightAndOpenPanel;
